<div class="flex flex-col max-w-256 md:min-w-120 max-h-screen overflow-hidden -m-6 gap-2">
  <div
    class="text-3xl font-semibold  border-gray-border flex flex-row justify-between border-b-2 border-gray-border px-5 py-3">
    @if (!isNote) {
      <span class="text-[#000] text-lg font-medium">Submit Your Inquiry</span>
    }
    @if (isNote) {
      <div class="flex gap-2">
        <img class="w-6 mt-1" src="assets/icons/note-forex-icon.svg">
        <span class="text-[#000] text-2xl font-semibold" >Important Notes</span>
      </div>
    }
    @if (!isPay) {
      <mat-icon svgIcon="close" class="black-text icon-size-6 cursor-pointer"
      (click)="matDialogRef.close()"></mat-icon>
    }
    @if (isPay) {
      <mat-icon svgIcon="close" class="black-text icon-size-6 cursor-pointer"
      (click)="payClose()"></mat-icon>
    }
  </div>

  <!-------Note----------->
  @if (isNote) {
    <div class="px-5 py-1">
      <ul class="list-disc ml-5 max-w-160">
        <li class="mb-1">Forex booking once done cannot be cancelled.</li>
        <li class="mb-1">Only Resident of India can do the booking for availing foreign exchange.</li>
        <li class="mb-1">Travel agent cannot buy any foreign exchange on behalf of their retail customers.</li>
        <li class="mb-1">Age limit of forex buying would be 18 years and above.</li>
        <li class="mb-1">Personal travel visit payment has to come from respective travellers(Indian Resident) Indian saving account.</li>
        <li class="mb-1">Business travel visit payment has to come from respective travellers company current account after providing one time company kycs to the respective money exchange vendor.</li>
        <li class="mb-1">Any foreign nationals has to call directly on company landline for the assistance of currency exchange.</li>
        <li class="mb-1">Any currency coins are not accepted.</li>
      </ul>
    </div>
  }

  <!-------Form----------->
  @if (!isPay && !isNote) {
    <form class="flex flex-col gap-0 w-full max-h-128 overflow-auto px-5" [formGroup]="formGroup">
      <div class="">
        <mat-form-field class="w-full">
          <mat-label class="text-[15px] text-[#414141] font-normal">Name</mat-label>
          <input class="p-0" matInput type="text" required [formControlName]="'lead_name'">
          @if (formGroup.get('lead_name').hasError('required')) {
            <mat-error>
              Name is required
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="w-full">
          <mat-label>Email Address</mat-label>
          <input id="email_0" matInput [formControlName]="'lead_email'">
          @if (formGroup.get('lead_email').hasError('required')) {
            <mat-error>
              Email address is required
            </mat-error>
          }
          @if (formGroup.get('lead_email').hasError('email')) {
            <mat-error>
              Please enter a valid email address
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="w-full">
          <mat-label>Mobile Number</mat-label>
          <input class="p-0" id="mobile" matInput type="text" placeholder="Mobile Number"
            [formControlName]="'lead_mobile'" (keypress)="numberOnly($event)">
            @if (formGroup.get('lead_mobile').hasError('required')) {
              <mat-error>
                Mobile number is required
              </mat-error>
            }
            @if (formGroup.get('lead_mobile').hasError('minlength')) {
              <mat-error>
                Mobile number must be 7 character long
              </mat-error>
            }
          </mat-form-field>
        </div>
      </form>
    }

    <!-------Payment----------->
    @if (isPay) {
      <div class="px-5 py-3 overflow-auto max-h-120">
        <div class="rounded-xl p-4 bg-[#F6F6F6]">
          <div class="pb-2 gap-2 flex text-[#1C1C1C] font-semibold text-base">
            <span>{{record.to_symbol_disp}}</span>
            <img class="w-auto" src="assets/icons/swift-inquiry.svg">
            <span>{{record.forex_symbol_disp}}</span>
          </div>
          <div class="flex gap-1"><span class="text-[#696969] text-sm font-medium">Forex Amount : </span><span
        class="text-black text-sm font-bold">{{record.forex_amount_symbol}} {{record.forex_amount}}</span></div>
        <div class="flex gap-1"><span class="text-[#696969] text-sm font-medium">BUY Exchange Rate :</span><span
      class="text-black text-sm font-bold">{{record.to_amount_symbol}} {{record.forex_rate}}</span></div>
      <div class="flex gap-1"><span class="text-[#696969] text-sm font-medium">INR Amount :</span><span
    class="text-black text-sm font-bold">{{record.to_amount_symbol}} {{record.to_amount}}</span></div>
  </div>
  <div class="rounded-xl p-4 bg-[#02A5432B] flex justify-between items-center my-4">
    <div class="grid">
      <span class="text-[#02A543] font-semibold text-base">Token Amount</span>
      <span class="text-[#02A543] font-normal text-xs">( Refundable )</span>
    </div>
    <div class="text-[#02A543] font-bold text-lg">
      {{record.inr_token_symbol}} {{tokan_amount_disp.toFixed(2)}}
    </div>
  </div>
  <div class="rounded-xl p-4 flex justify-between items-start my-4 gap-2"
    style="background: linear-gradient(90deg, #FFE8C7 0%, #FFF4E6 100%);">
    <div>
      <mat-icon class="text-[#D07B00] icon-size-5" svgIcon="heroicons_outline:information-circle"></mat-icon>
    </div>
    <div class="text-[#1C1C1C] font-normal text-sm max-w-[380px]">
      A token amount is required for this inquiry. It will be refunded
      if the transaction is completed successfully or if we are
      unable to fulfill it. If you cancel the inquiry, this amount is
      non-refundable.
    </div>
  </div>
  <!-------Payment Mode--------->
  <div
    class="method relative flex flex-col mb-5 white-bg rounded-lg border border-gray-border shadow-sm insurance-payment-booking">
    @if (PaymentValidateModel.chooseOne) {
      <mat-radio-group aria-label="Select an option"
        [(ngModel)]="PaymentValidateModel.payment_method">
        @if (bontonPanel.isB2B()) {
          <mat-radio-button value="Wallet"
            [ngClass]="PaymentValidateModel.walletdisable? 'pointer-events-none opacity-50':''"
            class="px-3 py-4 flex items-center border-b border-gray-border w-full cursor-pointer">
            <div class="flex items-center pr-1">
              <img src="assets/images/icon/wallet.webp" class="object-contain h-7 w-7 mr-3">
              <div class="flex flex-col theme-black-text">
                <span class="text-lg font-semibold leading-none">Wallet
                  <mat-icon
                    class="cursor-pointer icon-size-4 text-gray font-semibold relative ml-[2px] top-[2px]"
                  (click)="refresh()">refresh</mat-icon>
                </span>
                <div class="flex flex-col pt-1">
                  <span class="text-gray text-sm leading-snug">Available Balance: <span
                    class="theme-black-text font-medium">INR
                  {{PaymentValidateModel.walletBalance}}</span></span>
                  <span class="text-gray text-sm leading-snug">Credit Limit: <span
                    class="theme-black-text font-medium">INR
                  {{PaymentValidateModel.creditBalance}}</span></span>
                </div>
              </div>
            </div>
          </mat-radio-button>
        }
        @if (paymentMethods && paymentMethods?.includes('Online')) {
          <mat-radio-button value="Online" class="px-3 py-4 flex items-center w-full cursor-pointer">
            <div class="flex items-center">
              <img src="assets/images/icon/credit-card.webp" class="object-contain h-8 w-8 mr-3">
              <div class="flex flex-col theme-black-text leading-none">
                <span class="text-lg font-semibold">Online payment</span>
              </div>
            </div>
          </mat-radio-button>
        }
      </mat-radio-group>
    }
    @if (PaymentValidateModel.chooseTwo && bontonPanel.isB2B()) {
      <div>
        <mat-checkbox class="pl-3 py-4 flex items-center border-b border-gray-border w-full cursor-pointer"
          [(ngModel)]="payment_method_wallet"
          (click)="!payment_method_online ? payment_method_online = true : null">
          <div class="flex items-center pr-1">
            <img src="assets/images/icon/wallet.webp" class="object-contain h-7 w-7 mr-3">
            <div class="flex flex-col theme-black-text">
              <span class="text-lg font-semibold leading-none">Wallet
                <mat-icon
                class="cursor-pointer icon-size-4 text-gray font-semibold relative ml-[2px] top-[2px]">refresh</mat-icon>
              </span>
              <div class="flex flex-col pt-1">
                <span class="text-gray text-sm leading-snug">Available Balance: <span
                  class="theme-black-text font-medium">INR
                {{PaymentValidateModel.walletBalance}}</span></span>
                <span class="text-gray text-sm leading-snug">Credit Limit: <span
                  class="theme-black-text font-medium">INR
                {{PaymentValidateModel.creditBalance}}</span></span>
              </div>
            </div>
          </div>
        </mat-checkbox>
      </div>
    }
    @if (PaymentValidateModel.chooseTwo) {
      <div>
        <mat-checkbox class="pl-3 py-4 flex items-center w-full cursor-pointer"
          [(ngModel)]="payment_method_online"
          (click)="!payment_method_online ? payment_method_online = true : null">
          <div class="flex items-center">
            <img src="assets/images/icon/credit-card.webp" class="object-contain h-8 w-8 mr-3">
            <div class="flex flex-col theme-black-text leading-none">
              <span class="text-lg font-semibold">Online payment</span>
            </div>
          </div>
        </mat-checkbox>
      </div>
    }
    @if (paymentMethods?.includes('Online') && (PaymentValidateModel.payment_method == 'Online' || (PaymentValidateModel.chooseTwo && payment_method_online))) {
      <mat-radio-group aria-label="Select an option"
        [(ngModel)]="paymentMode" class="flex flex-col gap-3 px-3 py-4 border-t border-gray-border">
        @for (mode of paymentModesList; track mode) {
          <mat-radio-button [value]="mode" (click)="selectPaymentMode(mode)"
            class="px-3 py-3.5 border border-gray-border rounded-md flex items-center w-full cursor-pointer"
            >
            <div class="flex items-center bg-transparent">
              @if (mode?.mode.toLowerCase() == 'upi') {
                <img src="assets/images/icon/upi.svg" class="object-contain h-8 w-8 mr-3"
                  >
              }
              @if (mode?.mode.toLowerCase() == 'cb pay') {
                <img src="assets/images/icon/cb_pay.svg" class="object-contain h-8 w-8 mr-3"
                  >
              }
              @if (mode?.mode.toLowerCase() == 'debit card') {
                <img src="assets/images/icon/debit-card.svg" class="object-contain h-8 w-8 mr-3"
                  >
              }
              @if (mode?.mode.toLowerCase() == 'credit card' || mode?.mode.toLowerCase() == 'international card') {
                <img src="assets/images/icon/credit-card.svg" class="object-contain h-8 w-8 mr-3"
                  >
              }
              @if (mode?.mode.toLowerCase() == 'net banking') {
                <img src="assets/images/icon/net_banking.svg" class="object-contain h-8 w-8 mr-3"
                  >
              }
              <div class="flex flex-col theme-black-text leading-none">
                <span class="text-base font-semibold">{{mode?.mode}}</span>
                <span class="text-sm text-gray-600" [ngClass]="{ 'mt-1': mode?.description && mode?.description.trim().length > 0 }"
                  [class.line-clamp-2]="!mode.showFullDescription">
                  {{mode?.description}}
                </span>
                @if (mode.description && mode.description.length > paymentDescriptionCharacterLimit) {
                  <button
                    (click)="toggleDescription(mode); $event.stopPropagation()"
                    class="text-blue-500 text-sm mt-1 focus:outline-none text-left">
                    {{ mode.showFullDescription ? 'Read Less' : 'Read More' }}
                  </button>
                }
              </div>
            </div>
          </mat-radio-button>
        }
      </mat-radio-group>
    }
  </div>
</div>
}

<div class="justify-end items-end flex sticky bottom-0  white-bg px-5 py-3" [ngClass]="record && !record.isAgreeHide ? 'border-t-2 border-gray-border' : ''">
  @if (!isPay && !isNote) {
    <button mat-stroked-button color="primary"
      class="video-help-button rounded-lg w-full p-6 font-medium white-text " (click)="submit()"
      [disabled]="disableBtn">
      <span class="text-[#ffffff]">{{record.payment_mode == 'Inquiry Only' ? 'Submit' : 'Continue'}}</span>
    </button>
  }

  @if (isPay) {
    <button [disabled]="disableBtn" class="bg-[#01AF47] rounded-lg w-full p-4 font-medium" mat-ripple
      [matRippleCentered]="true" (click)="payment()">
      <span class="white-text tracking-wide">Pay {{record.inr_token_symbol}} {{tokan_amount_disp.toFixed(2)}}</span>
    </button>
  }

  @if (record && !record.isAgreeHide) {
    @if (isNote) {
      <button class=" px-10 py-3 text-lg text-white rounded-md font-medium" [ngClass]="this.bontonPanel.isB2B() ? 'bg-gradient-to-r from-[#234977] to-[#4F7BAF]' : 'primary-bg'" (click)="isAgree()">Agree</button>
    }
  }
</div>

</div>